import { CLocationRule, ILocationRule } from '@ts/ui-models';
import { postLocationRule } from '@services/DataBase/Location.service';

export const createLocationRules = async (
  dispatch,
  routeId: string,
  locationRules: ILocationRule[],
  options: { itemId: string }
) => {
  const listLocationRulesToCreate = locationRules || [];
  if (listLocationRulesToCreate.length === 0 || !options.itemId) {
    return Promise.resolve();
  }

  const promises: Promise<any>[] = listLocationRulesToCreate.map(locRul => {
    const copyLocRul = { ...locRul };
    if (routeId === 'itemTypeEdit' || routeId === 'locationTypeEdit') {
      copyLocRul.locationTypeId = options.itemId;
    }
    if (routeId === 'itemEdit' || routeId === 'locationEdit') {
      copyLocRul.locationId = options.itemId;
    }

    return postLocationRule(dispatch, new CLocationRule(copyLocRul));
  });

  return Promise.all(promises).then((responses: any[]) => {
    responses.forEach(response => {
      if (response?.error) {
        throw new Error(response.error.message);
      }
    });
  });
};
